import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

export type ChipProps = {
  selected?: boolean;
  onToggle?: (next: boolean) => void;
  children?: ReactNode;
  className?: string;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick' | 'type'>;

export const Chip = ({ selected = false, onToggle, children, className = '', ...rest }: ChipProps) => {
  const toggleable = onToggle !== undefined;
  return (
    <button
      type="button"
      role={toggleable ? 'checkbox' : undefined}
      aria-checked={toggleable ? selected : undefined}
      onClick={() => onToggle?.(!selected)}
      className={cx(
        'inline-flex min-h-tap items-center gap-1.5 rounded-sm border px-4 text-label transition-colors',
        selected ? 'border-teal-200 bg-teal-100 text-teal-700' : 'border-sage-300 bg-white text-ink',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
};
